<template>
  <div class="login-page page-padding-top">
    <div class="title" v-show="step == 1">{{ $t('huan-ying-deng-lu-fmall-ex', { appName: $store.state.appName }) }}</div>
    <div class="title" v-show="step == 2 && captchaEnabled">{{ $t('register.auth1') }}</div>
    <div class="title" v-show="step == 3">{{ $t('resetPassword.title4') }}</div>
    <div class="title" v-show="step == 4">{{ $t('she-zhi-you-xiang') }}</div>
    <div class="page-desc" v-show="step == 2 && captchaEnabled">{{$t('register.label4')}} {{tabIndex == 2? form.username : form.phone}} {{$t('register.label5')}}</div>

    <div class="tabs flex" v-show="step == 1">
      <div class="tab flex-center" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{ $t('shou-ji-zhu-ce') }}</div>
      <div class="tab flex-center" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{ $t('you-xiang-zhu-ce') }}</div>
    </div>


    <div class="login-form">
      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{ $t('you-xiang-hao-ma') }}</div>
      <div class="form-item  flex-center" v-if="tabIndex == 2 && step == 1">
        <div class="input">
          <input type="text" v-model="form.username" :placeholder="$t('qing-shu-ru-you-xiang-hao-ma-0')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{ $t('shou-ji-hao-ma') }}</div>
      <div class="form-item  flex-center " :class="inputActive ? 'active' : ''" v-if="tabIndex == 1 && step == 1">
        <a-select v-model="phonePre" option-label-prop="label" dropdownClassName="country-select" class="hide-border">
          <img :src="downUrl" slot="suffixIcon" class="suffix-icon">
          <a-select-opt-group  v-for="(item, i) in countryList" :key="i">
            <span slot="label">{{item.title}}</span>
            <a-select-option v-for="(child, index) in item.children" :key="index" :value="child.key" :label="child.key">
              {{child.title}}
            </a-select-option>
          </a-select-opt-group>
        </a-select>
        <div class="flex-1">
          <div class="input clear">
            <input type="tel" v-model="form.phone" @focus="inputActive = true" @blur="inputActive = false" :placeholder="$t('qing-shu-ru-shou-ji-hao-ma-0')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 3">
        {{ $t('register.label7') }} </div>

      <div class="form-item flex-center" v-show="step == 3" >
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" @blur="showPasswordAuth = false" v-model="form.password" :placeholder="$t('qing-shu-ru-deng-lu-mi-ma-0')">
        </div>
        <div class="adot" @click="changeShowPassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
        <div class="password-auth" v-show="showPasswordAuth ">
          <div class="auth-line flex-center-start" :class="passwordAuthList.indexOf(0) > -1 ? 'green' : ''">
            <img :src="passwordAuthList.indexOf(0) > -1 ? checkUrl2 : checkUrl" alt="">
            <span>{{ $t('register.passwordMinLength') }}</span>
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 3">
        {{$t('register.label8')}}
      </div>
      <div class="form-item clear flex-center" v-show="step == 3 " >
        <div class="input">
          <input :type="showSafePassword ? 'text' : 'password'" @input="changeConfirmPassword" v-model="form.confirmPassword" :placeholder="i18n.t('register.labelPlaceholder4')"/>
        </div>
        <div class="adot" @click="changeShowSafePassword">
          <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
        </div>
      </div>

      <div class="form-label" v-show="step == 1">
        {{ $t('yao-qing-ma-xuan-tian') }} </div>

      <div class="form-item clear flex-center" v-show="step == 1" >
        <div class="input">
          <input type="tel"  v-model="form.inviteCode"  :placeholder="$t('qing-shu-ru-yao-qing-ma')">
        </div>
      </div>

      <div class="form-label" v-if="step == 4">{{$t('register.label2')}}</div>
      <div class="form-item  flex-center" v-show="step == 4" >
        <div class="input">
          <input type="text" v-model="form.username"   :placeholder="i18n.t('register.labelPlaceholder1')">
        </div>
      </div>

      <div class="form-item clear flex-center mb-100" v-show="step == 2 && captchaEnabled" >
        <div class="input">
          <input type="tel"  v-model="form.code"  :placeholder="$t('qing-shu-ru-yan-zheng-ma')">
        </div>
        <div class="adot long" @click="changeShowSafePassword">
          <span class="gray" v-if="isDisabled">{{$t('register.send')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('register.btn1')}}</span>
        </div>
      </div>

    </div>

    <Checkbox v-model="checked" shape="square"  class="role " v-show="step == 1">
      <div @click="changeRole" icon-size="16">
        <span>{{ $t('wo-yi-yue-du-bing-tong-yi-fmallex', { appName: $store.state.appName }) }}</span>
        <span class="high" @click.stop="showRole(0)">{{ $t('pageTitle.agreement') }}</span>
        <span>{{ $t('register.role7') }}</span>
        <span class="high" @click.stop="showRole(1)">{{ $t('yin-si-tiao-yue') }}</span>
      </div>
    </Checkbox>


    <Button class="login-btn clear" @click="submit" :class="btnShow ? '' : 'disabled'">
      <template v-if="step == 1 && !captchaEnabled">
        {{ $t('xia-yi-bu') }}
      </template>
      <template v-else-if="step == 1">
        {{ $t('pageTitle.register') }}
      </template>
      <template v-else>
        {{ $t('pageTitle.register') }}
      </template>
    </Button>

    <div class="bottom-line flex-center-between " v-show="step == 1">
      <div class="blue" @click="toLogin">{{ $t('register.login') }}</div>
    </div>
  </div>
</template>
<script>
  import { Button, Popup, Icon, Checkbox } from 'vant'
  import { register, sendCode, checkEmailCode, sendSms, checkPhoneCode, userArticle } from '@/api/login'
  import { setToken, setUser, setUserId } from '@/utils/auth'
  import { isCaptchaEnabled } from '@/utils/captcha'
  import { normalizePassword, isPasswordLongEnough, validatePasswordPair } from '@/utils/passwordRules'
  export default {
    components: {
      Button,
      Popup,
      Icon,
      Checkbox
    },
    data() {
      return {
        step: 1,
        lineIndex: 0,
        form: {
          username: '',
          phone: '',
          password: '',
          confirmPassword: '',
          code: '',
          inviteCode: ''
        },
        checked: false,
        inputActive: false,
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        downUrl: require('../../assets/imgs/icon-arrow-down2.png'),
        checkUrl: require('../../assets/imgs/icon-close.png'),
        checkUrl2: require('../../assets/imgs/icon-check.png'),
        showPassword: false,
        showSafePassword: false,
        activeIndex: 1,
        isDisabled: false,
        sendTime: '',
        checkRole: false,
        showInvite: true,
        showPasswordAuth: false,
        passwordAuthList: [],
        phonePre: '+1',
        tabIndex: 1,
        showPopup: false,
        showRoleModal: false,
        countryList: [],
        keyword: '',
        serviceData: {},
        privacyData: {},
        roleData: {},
        linkList: []
      }
    },
    computed: {
      timeCount() {
        return this.sendTime + 's'
      },
      countryListBak() {
        return this.$store.state.countryList
      },
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable)
      },
      btnShow() {
        if (this.step == 1) {
          return (this.tabIndex == 2 && this.form.username) || (this.tabIndex == 1 && this.form.phone)
        } else if (this.step == 4) {
          return this.form.username
        } else if (this.step == 2) {
          // 如果验证码关闭,步骤2不需要验证码
          return !this.captchaEnabled || this.form.code
        } else if (this.step == 3) {
          return isPasswordLongEnough(this.form.password) && !!normalizePassword(this.form.confirmPassword)
        }
      }
    },
    mounted() {
      let code = this.$route.query.code
      if (code) {
        this.form.inviteCode = code
      }
      this.countryList = [].concat(this.countryListBak)
      this.initArticle()
         this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
    },
    methods: {
      initArticle() {
        let form = new FormData()
        let form2 = new FormData()
        form.append('Type', 0)
        form2.append('Type', 1)
        //服务条款
        userArticle(form).then(res => {
          let data = res.data.Items
          if (data && data.length > 0) {
            this.serviceData = data[0]
          }
        })
        //隐私策略
        userArticle(form2).then(res => {
          let data = res.data.Items
          if (data && data.length > 0) {
            this.privacyData = data[0]
          }
        })
      },
      changeTab(index) {
        if (this.step == 1) {
          this.tabIndex = index
        }
      },
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({ name: 'login', query: this.$route.query })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder2'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 1)
        if (this.tabIndex == 2) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.step = 3
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      submit() {
        if (!this.btnShow) {
          return
        }
        if (this.step == 1) {
          if (!this.checked) {
            this.$toast.fail(this.i18n.t('register.checkAgreement'))
            return
          }
          // 如果验证码关闭,直接跳到步骤3
          if (!this.captchaEnabled) {
            this.step = 3
          } else {
            if (this.tabIndex == 2) {
              this.sendEmail()
            } else {
              this.sendPhoneSms()
            }
          }
        }else if (this.step == 2) {
          this.toSet()
        } else {
          // 不管是手机注册还是邮箱注册，步骤3之后都直接提交
          this.doSubmit()
        }
      },
      doSubmit() {
        const validation = validatePasswordPair(this.form.password, this.form.confirmPassword)
        this.form.password = validation.password
        this.form.confirmPassword = validation.confirmPassword

        if (!validation.password) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder3'))
          return
        }
        if (validation.isTooShort) {
          this.$toast.fail(this.$t('register.passwordMinLength'))
          return
        }
        if (!validation.confirmPassword) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder4'))
          return
        }
        if (validation.isMismatch) {
          this.$toast.fail(this.i18n.t('register.passwordDiff'))
          return
        }

        let form = new FormData()
        // PC端: tabIndex == 1 是手机注册, tabIndex == 2 是邮箱注册
        if (this.tabIndex == 2) {
          form.append('Email', this.form.username)
        } else {
          form.append('Email', '') // 手机注册时Email为空
        }
        if (this.tabIndex == 1) {
          form.append('Phone', this.phonePre + this.form.phone)
          form.append('CountryCode', this.phonePre)
        }
        form.append('Password', validation.password)
        // form.append('SafePassword', this.form.safePassword) // Removed
        form.append('InviteCode', this.form.inviteCode)
        form.append('Code', this.form.code)
        register(form).then(res => {
          if (res.code == 0) {
            this.$toast(this.i18n.t('register.success'))
            this.toLogin()
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendPhoneSms(){
        if (!this.captchaEnabled) {
          return
        }
        if (!this.form.phone) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder8'))
          return
        }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        if (this.form.inviteCode) {
          form.append('Invite', this.form.inviteCode)
        }
        form.append('Type', 1)
        sendSms(form).then(res => {

          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail(){
        if (!this.captchaEnabled) {
          return
        }
        if (!this.form.username) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder1'))
          return
        }
        let form = new FormData()
        form.append('Email', this.form.username)
        if (this.form.inviteCode) {
          form.append('Invite', this.form.inviteCode)
        }
        form.append('Type', 1)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      cancel() {
        this.showPopup = false
        this.showRoleModal = false
      },
      checkCodeSize() {
        let code = this.form.code + ''
        if (code.length > 6) {
          code = code.substring(0, 6)
          this.form.code = parseInt(code)
        }
      },
      getCodeActive(i) {
        let code = this.form.code + ''
        if (!code) {
          return i == this.activeIndex ? 'active' : ''
        }
        return i == code.length + 1 ? 'active' : ''
      },
      inputCode() {
        this.activeIndex = 1
        this.$refs.codeInput.focus()
      },
      getCodeStr(i) {
        let code = this.form.code + ''
        if (!code) {
          return ''
        }
        let str = code.substring(i - 1, i)
        return str
      },
      resend() {
        if (!this.captchaEnabled || this.isDisabled) {
          return
        } else {
          if (this.tabIndex == 2) {
            this.sendEmail()
          } else {
            this.sendPhoneSms()
          }
        }
      },
      changeRole() {
        this.checkRole = !this.checkRole
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeShowSafePassword() {
        this.showSafePassword = !this.showSafePassword
      },
      changeShowInvite() {
        this.showInvite = !this.showInvite
      },
      changePassword() {
        this.form.password = normalizePassword(this.form.password)
        this.showPasswordAuth = !!this.form.password
        let result = []

        if (isPasswordLongEnough(this.form.password)) {
          result.push(0)
          this.lineIndex = 3
        } else {
          this.lineIndex = 0
        }

        this.passwordAuthList = result
      },
      changeConfirmPassword() {
        this.form.confirmPassword = normalizePassword(this.form.confirmPassword)
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1  && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      showRole(type) {
        if (type == 1) {
          this.$router.push({
            name: 'privacy'
          })
        } else {
          this.$router.push({
            name: 'agreement'
          })
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      }
    },
  }
</script>
